/**
 * AddSsaiParameterCtrl controller
 * Show all ssai settings
 */
import { SSAI_CONTENT_TYPES } from '../../app/core/constants'

/**
 * AddSsaiParameterCtrl controller
 *
 * @class AddSsaiParameterCtrl
 * @memberof mwApp/ssais
 * @see mwApp/ssais
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddSsaiParameterCtrl
 */
/* @ngInject */

export default function AddSsaiParameterCtrl ($scope, SsaiParameter, contentTypeKey, parameter, parameterTypes, macrosCatalog) {
  const vm = this

  vm.isNew = parameter._isNew()
  vm.parameter = parameter

  vm.contentTypeName = SSAI_CONTENT_TYPES[contentTypeKey].name

  vm.parameterTypes = parameterTypes

  vm.macrosCatalog = macrosCatalog

  vm.macrosByParameter = SsaiParameter.findMacros(parameter, macrosCatalog)

  vm.changeMacros = function (macros) {
    vm.parameter.$macros = macros
  }

  vm.changeCategory = function () {
    if (vm.parameter.$category &&
      !vm.parameter.$category.macros.find(m => m.id === vm.parameter.macroId)) {
      vm.parameter.macroId = null
    }
  }

  $scope.$watch('vm.parameter.$parameterType', (next, prev) => {
    if (prev !== next) {
      vm.parameter.$category = null
      vm.parameter.macroId = null
      vm.parameter.parameters = null
    }

    if (next === 'STATIC') {
      vm.parameter.$macros = vm.macrosCatalog?.STATIC[0]?.macros[0]
      vm.parameter.macroId = vm.macrosCatalog?.STATIC[0]?.macros[0]?.id || 0
    }
  })

  vm.submit = function () {
    if (vm.parameter.$macros && !vm.parameter.$macros.parameters.length) {
      vm.parameter.parameters = null
    }

    parameter._save()
      .then(vm.location(parameter).reload)
      .finally(vm.unsetDisable)
  }

  vm.delete = function () {
    parameter._delete()
      .then(() => vm.location.goBack())
  }

  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink(`ssais/${contentTypeKey}`)
  })
}
